import PendingInstituteActivationCard from "./cards/PendingInstituteActivationCard.vue"
import PendingOrganizationActivationCard from "./cards/PendingOrganizationActivationCard.vue"
import FormAcademyPersianDateField from "./fields/Form/PersianDateField.vue"

const academyModuleSetup = (app) => {

    /**
     * Register Cards
     */
    app.component('PendingInstituteActivationCard', PendingInstituteActivationCard)
    app.component('PendingOrganizationActivationCard', PendingOrganizationActivationCard)

    app.component('form-academy-persian-date-field', FormAcademyPersianDateField)

}

export { academyModuleSetup }
